export default "__VITE_ASSET__DPL_ogqR__"